import { FC, HTMLAttributes, memo } from "react";
import styles from "./icon.module.scss";
import Tooltip from "../Tooltip/Tooltip";
import { calcSizeFromValue } from "./helpers/calcSizeFromValue";
import { clss } from "../../utils/helpers/styleHelpers";
import { IconColorE, IconSizeE, TooltipPlaceE } from "../../models/enums";
import * as Icons from "./../../assets/icons";

type IconPropTypes = {
  name: string;
  alt?: string;
  title?: string;
  size?: IconSizeE;
  color?: IconColorE;
  className?: string;
  onClick?: (data: any) => void;
  tooltipPlace?: TooltipPlaceE;
  withoutTranslation?: boolean;
  tooltipBackground?: string;
  tooltipClassName?: string;
  iconProps?: HTMLAttributes<HTMLImageElement>;
  isShowTooltip?: boolean;
};

const Icon: FC<IconPropTypes> = memo(
  ({
    name,
    alt,
    title,
    size,
    color = IconColorE.BLACK,
    className = "",
    onClick,
    tooltipPlace = TooltipPlaceE.TOP,
    withoutTranslation,
    tooltipBackground = "#333",
    iconProps,
    tooltipClassName,
    isShowTooltip,
  }) => {
    return (
      <Tooltip
        text={title}
        place={tooltipPlace}
        withoutTranslation={withoutTranslation}
        backgroundColor={tooltipBackground}
        addTooltipClassName={tooltipClassName}
        isShowTooltip={isShowTooltip}
      >
        <img
          src={Icons[name]}
          alt={alt || name}
          {...calcSizeFromValue(size)}
          className={clss([className, styles[color]])}
          onClick={onClick}
          {...iconProps}
        />
      </Tooltip>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.name === nextProps.name &&
      prevProps.color === nextProps.color &&
      prevProps.title === nextProps.title &&
      prevProps.className === nextProps.className
    );
  }
);

export default Icon;
